import React from 'react'
import { BadgeVariant, Flex, Modal, StatusBadge } from '@mprolab/uikit'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { StakeProgress, stakeStore } from 'mobxStores/StakeStore'
import { getErrorCodesDescription } from 'utils/getErrorCodesDescription'
import ChainScanFooter from 'components/ChainScanFooter'

const ContentWrapper = styled(Flex)`
  flex-direction: column;
  margin-top: 32px;
  width: 550px;
  ${({ theme }) => theme.mediaQueries.mobile} {
    width: 100%;
  }
`

const BadgeWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
`

interface JoinStakeProps {
  onDismiss?: () => void
}

const ClaimStakeModal: React.FC<JoinStakeProps> = observer(({ onDismiss }) => {
  const { stake, stakeProgress, error, txHash } = stakeStore
  const { t } = useTranslation()

  const content = () => {
    switch (stakeProgress) {
      case StakeProgress.INITIAL:
      case StakeProgress.CONFIRMING:
      case StakeProgress.PENDING:
        return (
          <BadgeWrapper>
            <StatusBadge title={t('modal.continueInWallet')} variant={BadgeVariant.PENDING} />
          </BadgeWrapper>
        )
      case StakeProgress.SUCCESS:
        return (
          <Flex flexDirection="column" gap="16px">
            <BadgeWrapper>
              <StatusBadge title={t('modal.transactionSucessful')} variant={BadgeVariant.SUCCESS} />
            </BadgeWrapper>
            <ChainScanFooter chainId={stake.chainId} transactionHash={txHash} />
          </Flex>
        )
      case StakeProgress.ERROR:
      case StakeProgress.REJECTED:
        return (
          <BadgeWrapper>
            <StatusBadge title={getErrorCodesDescription(t, error)} variant={BadgeVariant.ERROR} />
          </BadgeWrapper>
        )

      default:
        return <></>
    }
  }

  const modalTitle = () => {
    switch (stakeProgress) {
      case StakeProgress.INITIAL:
        return `${t('stakingPanel.claimReward')} ${stake.rewardToken.token}`
      case StakeProgress.PENDING:
      case StakeProgress.CONFIRMING:
        return t('modal.confirmTransaction')
      case StakeProgress.SUCCESS:
        return t('stakingPanel.claimSuccess')
      case StakeProgress.ERROR:
        return t('modal.claimFailed')
      case StakeProgress.REJECTED:
        return t('modal.rejected')
      default:
        return ''
    }
  }

  return (
    <Modal onDismiss={onDismiss} hideCloseButton={false} title={modalTitle()}>
      <ContentWrapper>{content()}</ContentWrapper>
    </Modal>
  )
})

export default ClaimStakeModal
